import { Component, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector: 'award-title',
	templateUrl: './award-title.component.html',
	styleUrls: ['./award-title.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AwardTitleComponent {

	@Input() align: string = 'left';

	constructor() {}

	ngOnInit() {}
}